<template>
    <div id="dvtop">   
        <centralnotificacao></centralnotificacao>     
        <whatsnew></whatsnew>   
        <nav id="navbarmenu" class="navbar fixed-top navbar-expand-md bg-dark navbar-dark">
            <button type="button" class="btn btn-dark" style="margin-left: -10px; margin-right: 5px; border-radius: 8px!important;" @click.prevent="openNav"><i class="fa fa-navicon"></i></button>
            <a class="navbar-brand" id="fantasia-filial" href="#/">
                {{ filial.fantasia }}
                <button type="button" class="btn btn-green btn-sm" id="btn-suporte-on-line" @click.prevent="rtchat()" style="margin-left: 10px; border-radius: 15px!important;" title="Suporte On Line">
                    <i class="fa fa-comments"></i> SUPORTE ON LINE
                </button>  
            </a>
            <button type="button" class="btn btn-green btn-sm" id="btn-suporte-on-line-small" @click.prevent="rtchat()" title="Suporte On Line">
                <i class="fa fa-comments"></i>
            </button>    
                     
            <div class="collapse navbar-collapse" id="collapsibleNavbar">
                <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                </ul>
            </div>
            <span class="navbar-text">
                <ul id="lst-icones-menu-nav">
                    <li>
                        <img src="../assets/icone_dash.svg" class="btn-dashboard" title="Acesse a dashboard" @click.prevent="$router.push('/dashboard')">
                    </li>
                    <!-- <li>
                        <span class="icone-menu-bar" @click.prevent="mtdwhatsnew()" title="O que há de novo"><i class="fa fa-bullhorn"></i></span>                        
                        <span v-show="qtdatzs > 0" class="badge badge-pill badge-warning badge-whatsnew">{{ qtdatzs }}</span>             
                    </li>  -->
                    <li>
                        <span class="icone-menu-bar" @click.prevent="mtdcentralnotificacao()" title="Central de notificações"><i class="fa fa-flag"></i></span>                        
                    </li> 
                    <li>
                        <span class="icone-menu-bar" @click.prevent="mtdrotinascoletor()" title="Coletor de produtos"><i class="fa fa-inbox"></i></span>                        
                        <span v-show="lstitenscoletor.length > 0" class="badge badge-pill badge-warning badge-itens-coletor">{{lstitenscoletor.length}}</span>
                    </li>                    
                    <li>
                        <div class="dropdown">
                            <span class="icone-menu-bar" aria-expanded="false" title="Notificações" data-toggle="dropdown">
                                <i class="fa fa-bell"></i>
                                <span v-show="qtdnotificacoes > 0" class="badge badge-pill badge-danger badge-notfusu">{{qtdnotificacoes}}</span>
                            </span>
                            <div v-show="qtdnotificacoes > 0" class="dropdown-menu drop-notificacoes animate slideIn">
                                <div class="container-fluid" style="padding: 0px;">
                                    <ul class="list-group" style="width: 100%;">
                                        <li class="list-group-item active">
                                            <i class="fa fa-bell"></i> Notificações
                                            <span id="limpar-notificacao" @click.prevent="mtdlimparnotificacoes(0)">Limpar tudo</span>
                                        </li>
                                        <div style="max-height: 273px; overflow: auto;">
                                            <li v-for="(notificacao, indice) in lstnotificacoes" :key="indice" @click.prevent="mtddetalhesnotificacao(notificacao)" class="list-group-item list-group-item-action" style="padding-bottom: 20px; cursor: pointer;">
                                                <template v-if="parseInt(notificacao.tipo) === 1">
                                                    <span><i class="fa fa-certificate" style="font-size: 22px; color: #f82b54;"></i></span>
                                                </template> 
                                                <template v-else-if="parseInt(notificacao.tipo) === 10">
                                                    <span><i class="fa fa-flag" style="font-size: 22px; color: #2ba9f8;"></i></span>
                                                </template>                                            
                                                <template v-else>
                                                    <img  v-bind:src="pathfotos+notificacao.foto" class="img-usutarefa img-usuario-notificacao" data-toggle="tooltip" v-bind:title="'Registrada por: '+notificacao.nomeusu">
                                                </template>
                                                <span class="tit-notificacao" v-bind:title="notificacao.descnotificacao">{{ notificacao.descnotificacao }}</span>
                                                <span class="data-notificacao">{{ notificacao.dtemissao }}</span>
                                            </li>

                                            <li v-for="(titulo, indice) in lstBoletosDisp" :key="indice" class="list-group-item list-group-item-action" style="padding-bottom: 20px;">
                                                <span v-if="parseInt(titulo.statusapi)!==1" title="Pagar via RillPay" >
                                                    <svg @click.prevent="mtdpagamentopix(titulo)" 
                                                        xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="13.3247mm" height="6.649mm" version="1.1" 
                                                        style="margin-top: 5px; cursor: pointer; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                                                        viewBox="0 0 194.64 74.7"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
                                                        <g id="Camada_x0020_1">
                                                        <metadata id="CorelCorpID_0Corel-Layer"/>
                                                        <path class="fil0" d="M1.09 30.95l13.17 -23.61 23.17 -5.93 -20.43 38.33 -15.92 -8.79zm177.79 -7.27c0,-2.61 -0.47,-4.76 -1.39,-6.45 -0.92,-1.69 -2.06,-2.94 -3.41,-3.74 -1.35,-0.8 -2.76,-1.31 -4.23,-1.53 -1.49,-0.22 -3.02,-0.31 -4.61,-0.31l-6.47 0 0 25.29 6.82 0c2.43,0 4.45,-0.33 6.1,-0.98 1.63,-0.65 2.98,-1.57 4.02,-2.74 1.04,-1.16 1.82,-2.57 2.37,-4.2 0.53,-1.63 0.8,-3.41 0.8,-5.33zm15.76 -1.1c0,4.2 -0.65,7.88 -1.96,11.1 -1.29,3.23 -3.2,5.94 -5.71,8.14 -2.49,2.22 -5.55,3.88 -9.18,5.04 -3.63,1.16 -7.9,1.73 -12.82,1.73l-6.22 0 0 23.7c0,0.39 -0.12,0.72 -0.37,1.04 -0.26,0.29 -0.67,0.55 -1.23,0.74 -0.57,0.2 -1.33,0.33 -2.29,0.45 -0.94,0.12 -2.18,0.18 -3.65,0.18 -1.45,0 -2.67,-0.06 -3.65,-0.18 -0.98,-0.12 -1.74,-0.27 -2.31,-0.45 -0.57,-0.2 -0.98,-0.45 -1.2,-0.74 -0.23,-0.31 -0.35,-0.67 -0.35,-1.04l0 -66.88c0,-1.8 0.47,-3.16 1.41,-4.06 0.94,-0.9 2.18,-1.35 3.71,-1.35l17.53 0c1.76,0 3.45,0.06 5.04,0.2 1.59,0.14 3.49,0.43 5.73,0.86 2.22,0.45 4.47,1.25 6.75,2.45 2.27,1.18 4.23,2.69 5.84,4.51 1.61,1.82 2.84,3.94 3.69,6.39 0.84,2.43 1.25,5.16 1.25,8.18zm-81.52 -0.67c0,-2.45 -0.55,-4.53 -1.67,-6.2 -1.12,-1.69 -2.94,-2.88 -5.47,-3.57 -0.76,-0.2 -1.63,-0.33 -2.61,-0.45 -0.98,-0.12 -2.33,-0.18 -4.06,-0.18l-6.78 0 0 21.06 7.7 0c2.16,0 4.02,-0.26 5.63,-0.78 1.63,-0.51 2.96,-1.23 4.04,-2.18 1.08,-0.92 1.88,-2.06 2.41,-3.35 0.53,-1.29 0.8,-2.74 0.8,-4.35zm19.53 50.49c0,0.41 -0.08,0.77 -0.23,1.06 -0.16,0.29 -0.51,0.53 -1.08,0.72 -0.59,0.18 -1.41,0.31 -2.53,0.39 -1.12,0.08 -2.63,0.12 -4.53,0.12 -1.61,0 -2.88,-0.04 -3.84,-0.12 -0.96,-0.08 -1.73,-0.22 -2.27,-0.43 -0.55,-0.21 -0.94,-0.47 -1.18,-0.8 -0.22,-0.33 -0.41,-0.73 -0.57,-1.18l-6.71 -16.65c-0.8,-1.88 -1.59,-3.57 -2.35,-5.02 -0.77,-1.47 -1.63,-2.69 -2.57,-3.67 -0.94,-0.98 -2.04,-1.71 -3.27,-2.22 -1.22,-0.49 -2.65,-0.75 -4.25,-0.75l-4.72 0 0 28.41c0,0.37 -0.12,0.72 -0.37,1.02 -0.26,0.31 -0.67,0.57 -1.23,0.77 -0.57,0.18 -1.33,0.33 -2.29,0.45 -0.94,0.12 -2.18,0.18 -3.65,0.18 -1.45,0 -2.67,-0.06 -3.65,-0.18 -0.98,-0.12 -1.74,-0.27 -2.31,-0.45 -0.57,-0.2 -0.98,-0.45 -1.2,-0.74 -0.23,-0.31 -0.35,-0.67 -0.35,-1.04l0 -67.52c0,-1.69 0.43,-2.9 1.29,-3.65 0.86,-0.75 1.92,-1.12 3.18,-1.12l19.25 0c1.94,0 3.57,0.04 4.82,0.12 1.25,0.08 2.41,0.18 3.45,0.27 2.98,0.43 5.67,1.16 8.06,2.2 2.39,1.02 4.43,2.37 6.1,4.04 1.67,1.67 2.94,3.63 3.82,5.9 0.88,2.28 1.31,4.88 1.31,7.84 0,2.47 -0.31,4.74 -0.94,6.78 -0.65,2.06 -1.57,3.88 -2.8,5.49 -1.22,1.61 -2.73,3 -4.53,4.18 -1.8,1.2 -3.86,2.14 -6.16,2.88 1.12,0.53 2.16,1.18 3.14,1.94 0.98,0.77 1.9,1.71 2.76,2.8 0.86,1.1 1.69,2.33 2.45,3.75 0.77,1.39 1.51,2.98 2.24,4.74l6.29 14.68c0.57,1.45 0.96,2.51 1.14,3.2 0.2,0.67 0.29,1.2 0.29,1.59zm-62.42 -27.59l-13.19 23.6 -23.17 5.92 20.44 -38.31 15.92 8.79z"/>
                                                        <path class="fil1" d="M29.19 72.89l-23.49 -13.4 -5.71 -23.22 38.13 20.78 -8.93 15.84zm13.5 -69.69l23.37 13.6 5.51 23.27 -37.95 -21.11 9.07 -15.76z"/>
                                                        </g>
                                                    </svg>
                                                </span>
                                                <span v-else><i class="fa fa-barcode" style="font-size: 22px; color: #0acf97; margin-top: 10px;  cursor: pointer;" @click.prevent="mtdimprimirboleto(titulo)" title="Pagar via boleto"></i></span>
                                                <span class="tit-notificacao"  style="left: 82px;">Fatura disponível</span>
                                                <span class="data-notificacao" style="left: 82px;">Vencimento: {{ titulo.dtventit }}</span>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>                            
                        </div>
                    </li>
                    <li>
                        <span class="icone-menu-bar" @click.prevent="mtdlogoff()" title="Sair"><i class="fa fa-sign-out"></i></span>                        
                    </li>
                </ul>
            </span>            
        </nav>
        <div id="mySidenav" @mouseleave="closeNav" class="sidenav">
            <div id="dvconteudo-side-nav" class="container-fluid" style="display: none;">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 dv-borda-bottom">
                        <h5 id="nome-empresa">{{usuario.sistema}}</h5>
                        <span href="#" class="closebtn" @click.prevent="closeNav">&times;</span>                        
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 dv-borda-bottom" id="dv-icones-small">
                        <ul id="lst-icones-menu-nav">
                            <li>
                                <img src="../assets/icone_dash.svg" class="btn-dashboard" title="Acesse a dashboard" @click.prevent="$router.push('/dashboard')" style="">
                            </li>                            
                            <!-- <li>
                                <span class="icone-menu-bar" @click.prevent="mtdwhatsnew()" title="O que há de novo"><i class="fa fa-bullhorn"></i></span>                        
                                <span v-show="qtdatzs > 0" class="badge badge-pill badge-warning badge-whatsnew">{{ qtdatzs }}</span>             
                            </li>  -->
                            <li>
                                <span class="icone-menu-bar" @click.prevent="mtdcentralnotificacao()" title="Central de notificações"><i class="fa fa-flag"></i></span>                        
                            </li> 
                            <li>
                                <span class="icone-menu-bar" @click.prevent="mtdrotinascoletor()" title="Coletor de produtos"><i class="fa fa-inbox"></i></span>                        
                                <span v-show="lstitenscoletor.length > 0" class="badge badge-pill badge-warning badge-itens-coletor">{{lstitenscoletor.length}}</span>
                            </li>  
                            <li>
                                <span class="icone-menu-bar" @click.prevent="mtdopennotificacoesmini()" title="Notificações"><i class="fa fa-bell"></i></span>                        
                                <span v-show="qtdnotificacoes > 0" class="badge badge-pill badge-danger badge-notfusu-mini">{{qtdnotificacoes}}</span>
                            </li>                   
                            <li>
                
                                <!-- <div class="dropdown">
                                    <span class="icone-menu-bar" aria-expanded="false" title="Notificações" data-toggle="dropdown">
                                        <i class="fa fa-bell"></i>
                                        <span v-show="qtdnotificacoes > 0" class="badge badge-pill badge-danger badge-notfusu">{{qtdnotificacoes}}</span>
                                    </span>
                                    <div v-show="qtdnotificacoes > 0" class="dropdown-menu drop-notificacoes-mini dropdown-menu-right">
                                        <div class="container-fluid" style="padding: 0px;">
                                            <ul class="list-group" style="width: 100%;">
                                                <li class="list-group-item active">
                                                    <i class="fa fa-bell"></i> Notificações
                                                    <span id="limpar-notificacao" @click.prevent="mtdlimparnotificacoes(0)">Limpar tudo</span>
                                                </li>
                                                <div style="max-height: 273px; overflow: auto;">
                                                    <li v-for="(notificacao, indice) in lstnotificacoes" :key="indice" @click.prevent="mtddetalhesnotificacao(notificacao)" class="list-group-item list-group-item-action" style="padding-bottom: 20px; cursor: pointer;">
                                                        <template v-if="parseInt(notificacao.tipo) === 1">
                                                            <span><i class="fa fa-certificate" style="font-size: 22px; color: #f82b54;"></i></span>
                                                        </template> 
                                                        <template v-else-if="parseInt(notificacao.tipo) === 10">
                                                            <span><i class="fa fa-flag" style="font-size: 22px; color: #2ba9f8;"></i></span>
                                                        </template>                                            
                                                        <template v-else>
                                                            <img  v-bind:src="pathfotos+notificacao.foto" class="img-usutarefa img-usuario-notificacao" data-toggle="tooltip" v-bind:title="'Registrada por: '+notificacao.nomeusu">
                                                        </template>
                                                        <span class="tit-notificacao" v-bind:title="notificacao.descnotificacao">{{ notificacao.descnotificacao }}</span>
                                                        <span class="data-notificacao">{{ notificacao.dtemissao }}</span>
                                                    </li>

                                                    <li v-for="(titulo, indice) in lstBoletosDisp" :key="indice" class="list-group-item list-group-item-action" style="padding-bottom: 20px;">
                                                        <span v-if="parseInt(titulo.statusapi)!==1"><i class="fa fa-qrcode"  style="font-size: 22px; margin-top: 10px; margin-left: 5px; cursor: pointer;" @click.prevent="mtdpagamentopix(titulo)" title="Pagar via PIX"></i></span>
                                                        <span v-else><i class="fa fa-barcode" style="font-size: 22px; color: #0acf97; margin-top: 10px;  cursor: pointer;" @click.prevent="mtdimprimirboleto(titulo)" title="Pagar via boleto"></i></span>
                                                        <span class="tit-notificacao"  style="left: 75px;">Fatura disponível</span>
                                                        <span class="data-notificacao" style="left: 75px;">Vencimento: {{ titulo.dtventit }}</span>
                                                    </li>
                                                </div>
                                            </ul>
                                        </div>
                                    </div>                            
                                </div> -->
                            </li>
                            <li>
                                <span class="icone-menu-bar" @click.prevent="mtdlogoff()" title="Sair"><i class="fa fa-sign-out"></i></span>                        
                            </li>
                        </ul>
                    </div>                    
                    <div class="col-12 col-sm-12 col-md-12 dv-borda-bottom">
                        <div class="row dados-usuario">
                            <div class="col-4 col-sm-4 col-md-4 text-center">
                                <img id="img-foto-usuario" class="img-fluid" v-bind:src="pathfotovisualizar+usuario.foto" @click.prevent="mtddefinicoesusuario()" style="cursor: pointer;" title="Clique aqui para alterar sua senha e/ou foto.">
                            </div>
                            <div class="col-8 col-sm-8 col-md-8" style="padding-left: 0px;">
                                <h5 id="nome-usuario">{{ usuario.nome }}</h5>
                                <h5 id="grupo-usuario">{{ usuario.descgrupo }}</h5>
                            </div>                            
                        </div>
                    </div>
                    <div class="col-md-12 dv-borda-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="input-group">
                                    <input type="text" class="form-control" id="edpesquisamenu" v-model="vcontpesqrapida" placeholder="Pesquisar..." autocomplete="off">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="btpesquisarmenu">
                                        <i class="fa fa-search" aria-hidden="true"></i>
                                    </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="lstlistaresultado.length > 0" class="col-md-12" style="margin-top: 2px;">
                                <ul class="grupo-lista-pesquisa" style="margin-bottom: 0px;">
                                    <li v-for="(item, index) in lstlistaresultado" v-bind:key="index" style="list-style-type: none; padding: 0px; min-height: 20px;">
                                        <router-link v-bind:to="item.link">{{item.menu.toUpperCase()}}</router-link>
                                    </li>
                                </ul>
                            </div>                        
                        </div>
                    </div>
                    <div class="col-md-12 dv-borda-bottom" style="padding-top: 5px;">
                        <div class="row">
                            <div class="col-md-12">
                                <h6 style="font-size: 12px; font-weight: bold; color: #2c5569;">MENU</h6>
                            </div>
                            <div class="col-md-12" style="padding: 0px; margin-bottom: -16px;">
                                <ul v-show="menuindividual.length >= 0" id="grupo-lista-menu">
                                    <template v-for="(menu, index) in menuindividual">
                                        <li v-if="parseInt(menu.habilita) === 1" v-bind:key="index">
                                            <a data-toggle="collapse" v-bind:href="'#menu'+index"><span class="icone-menu"><i v-bind:class="menu.icone"></i></span> {{primeiramaiuscula(menu.menu)}}<i v-if="mtdversaodisponivel(menu.codop)" class="fa fa-certificate icone-vestendida" title="Disponível na versão estendida"></i><i class="fa fa-chevron-right icone-rotate"></i></a>
                                            <ul class="grupo-lista-submenu collapse" v-bind:id="'menu'+index">
                                                <li>
                                                    <template v-for="(item, indexi) in menu.submenu">
                                                        <template v-if="item.menu !== '-'">
                                                            <router-link v-bind:key="indexi" v-if="parseInt(item.habilita) === 1" v-bind:to="item.link"><i v-if="mtdversaodisponivel(item.codop)" class="fa fa-certificate icone-vestendida" title="Disponível na versão estendida"></i> {{primeiramaiuscula(item.menu)}}</router-link>
                                                        </template>                                                        
                                                    </template>
                                                </li>                                            
                                            </ul>
                                        </li>
                                    </template>    
                                </ul>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
        <!-- Modal para visualização do detalhe da notificação -->
        <div class="modal fade" id="mdldetnotificacao" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalScrollableTitle" style="font-size: 18px;"><i class="fa fa-bell"></i> {{ detnotificacao.descnotificacao }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="jumbotron" style="margin-bottom: 0px; padding: 40px 15px 40px 15px;">
                                    <div class="row">
                                        <div class="col-md-12 text-center" style="margin-bottom: 15px;">
                                            <template v-if="parseInt(detnotificacao.tipo) === 1">
                                                <span><i class="fa fa-certificate icon-validade-cert"></i></span>
                                            </template>
                                            <template v-else-if="parseInt(detnotificacao.tipo) === 10">
                                                <span><i class="fa fa-flag icon-novos-ncms"></i></span>
                                            </template>
                            
                                            <template v-else>
                                                <img v-if="detnotificacao.foto !== 'undefined'" v-bind:src="pathfotos+detnotificacao.foto" class="img-usutarefa img-usuario-notificacao" style="width: 60px!important; height: 60px!important;">
                                            </template>
                                        </div>
                                        <div class="col-md-12" style="margin-bottom: 10px;">
                                            <h6 v-if="parseInt(detnotificacao.tipo) === 1">Emissão: {{ detnotificacao.dtemissao }}, por Manager Web.</h6> 
                                            <h6 v-else-if="parseInt(detnotificacao.tipo) === 10">Emissão: {{ detnotificacao.dtemissao }}, por Manager Web.</h6>                                            
                                            <h6 v-else>Emissão: {{ detnotificacao.dtemissao }}, por {{ detnotificacao.nomeusu }}.</h6>                                            
                                        </div>
                                    
                                        <div id="conteudonotif" class="col-md-12">
                                            <p>{{ detnotificacao.conteudonotificacao }}</p>                                            
                                            <p v-if="parseInt(detnotificacao.tipo) === 0"><strong>Tarefa:</strong> {{ detnotificacao.titulotarefa }}</p>                                            
                                       
                                        </div>   
                                        <div class="col-md-12 text-center">
                                            <template  v-if="parseInt(detnotificacao.tipo) === 10">
                                                <router-link to="/cadncm">
                                                    <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal"><i class="fa fa-flag"></i> Verificar</button>
                                                </router-link>
                                            </template>
                                        </div>                                                                                                                                                                            
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
         <!-- Modal para visualização do detalhe da notificação personalizada - guga 🤠 -->
        <div class="modal fade" id="mdldetnotificacaouser" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content" style="margin: -5px;">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalScrollableTitle" style="font-size: 18px;"><i :class="detnotificacao.adesivo"></i> {{ detnotificacao.descnotificacao }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div style="width: 100%;" class="row">
                                    <div class="col-3">
                                        <div class="col-md-12 text-center jumbotron d-flex align-items-center justify-content-center" style="padding-top: 6px; padding-bottom: 8px; border-radius: 100%; width: 68px;">
                                            <i style="font-size: 50px; " :class="detnotificacao.adesivo +' '+detnotificacao.cor"></i>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="col-md-12 text-center" style="padding-top: 20px;">
                                            <h6>{{ detnotificacao.descnotificacao }}</h6> 
                                        </div>
                                    </div>
                                    <div style="width: 100%; align-items: center;" class="col-3">
                                        <div class="row d-flex align-items-center justify-content-center">
                                            <img v-if="detnotificacao.foto !== 'undefined'" v-bind:src="pathfotos+detnotificacao.foto" class="img-usutarefa img-usuario-notificacao" style="width: 35px!important; height: 35px!important; ">
                                            <span style="font-size: 8px; text-align: center; width: 100%;">Emissão: {{ detnotificacao.dtemissao }}, por {{ detnotificacao.nomeusu }}.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="jumbotron" style="margin-bottom: 0px; padding: 40px 15px 40px 15px; width: 100%;">
                                    <div class="row">
                                        <div id="conteudonotifexp" class="col-md-12">
                                              
                                        </div>                                                                                                                                                                               
                                    </div>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal pra redefinição de senha e foto do usuário -->
        <div class="modal fade" id="mddefinicoesusuario">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" style="font-size: 16px;">Definições do usuário</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="col-md-12 text-center border rounded" style="padding-top: 10px; padding-bottom: 10px;">
                                    <img id="img-usuario-def" class="img-thumbnail" 
                                    v-bind:src="pathfotovisualizar+usuario.foto" 
                                    data-toggle="tooltip" 
                                    title="Clique na foto para alterar" 
                                    data-placement="bottom"
                                    @click="$refs.if_imgusuariodef.click()">
                                    <div class="col-md-12 text-center">
                                        <input type="file" 
                                        accept="image/png, image/jpeg"
                                        id="btselecionarimagemusudef" 
                                        @change="mtdselecionarimagemusuariodef" 
                                        style="display: none;"
                                        ref="if_imgusuariodef">
                                    </div>
                                </div>
                            </div>

                            <div style="padding-bottom: 20px;" class="col-md-12">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="switchexibcards" v-model="exibicaocard" @change="mtdmudarexibicaocard()">
                                    <label class="custom-control-label" for="switchexibcards">Exibir listagem em cards</label>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <label for="edsenhaantigadef">Senha antiga:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhaantigadef" v-model="asenha_antiga" data-bv-group=".group" maxlength="20">
                            </div>
                            <div class="col-md-12">
                                <label for="edsenhanovadef">Nova senha:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhanovadef" v-model="asenha_nova" data-bv-group=".group" maxlength="20">
                            </div>
                            <div class="col-md-12">
                                <label for="edsenhaconfirmadef">Confirmar senha:</label>
                                <input type="password" class="form-control form-control-sm" id="edsenhaconfirmadef" v-model="asenha_repete" data-bv-group=".group" maxlength="20">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" id="btalterarsenhausudef" class="btn btn-primary btn-sm" role="button" style="min-width: 100px;" @click.prevent="mtdalterarsenhausuario()"><i class="fa fa-check-circle"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="min-width: 100px;"><i class="fa fa-close"></i> Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal do coletor de produtos -->
        <div class="modal fade" id="mdlcoletor" tabindex="-1" role="dialog" aria-labelledby="titulocoletor" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="titulocoletor" style="font-size: 18px;"><i class="fa fa-inbox"></i> Coletor de produtos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12" style="margin-top: 10px;">
                                    <vue-bootstrap4-table
                                            :rows="lstitenscoletor"
                                            :columns="columns"
                                            :config="config"
                                            :classes="classes">
                                        <template slot="empty-results">
                                            <div class="col-md-12 text-center">Sem dados para visualização</div>
                                        </template>
                                        <!-- ícones de ordenação da table -->
                                        <template slot="sort-asc-icon">
                                            <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                        </template>
                                        <template slot="sort-desc-icon">
                                            <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                        </template>
                                        <template slot="no-sort-icon">
                                            <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                        </template>                                    
                                        <!--  -->                                    
                                        <template slot="slot_idproduto" slot-scope="item">
                                            {{ item.row.idproduto }}
                                        </template>
                                        <template slot="opcoes" slot-scope="item">
                                            <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalteraritemcoletor(item.row)"><i class="fa fa-edit"></i></button>
                                            <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdrotinaitemcoletor(item.row, 3, 0)"><i class="fa fa-trash"></i></button>
                                        </template>
                                    </vue-bootstrap4-table>
                                </div>                                
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" style="width: 140px;" @click.prevent="mtdlimparcoletor()"><i class="fa fa-eraser"></i> Limpar coletor</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 140px;"><i class="fa fa-close"></i> Fechar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal do coletor para edição de quantidade -->
        <div class="modal fade" id="mdleditaitemcoletor" tabindex="-1" role="dialog" aria-labelledby="titulocoletoritem" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="titulocoletoritem" style="font-size: 18px;"><i class="fa fa-edit"></i> Alteração de quantidade</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="edqtdcoletor">Quantidade:</label>
                                    <money class="form-control form-control-sm" id="edqtdcoletor" 
                                        v-model="qtditemalteracaocoletor"
                                        data-bv-group=".group" style="text-align:right;"></money>
                                </div>                                 
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdrotinaitemcoletor(itemalteracaocoletor, 5, qtditemalteracaocoletor)"><i class="fa fa-check"></i> Confirmar</button>
                    </div>
                </div>
            </div>
        </div>        
        <!-- Modal regualização -->
        <div class="modal fade" id="mdlregularizar" role="dialog" aria-hidden="true" data-backdrop="static">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body text-justify">
                        <div class="jumbotron" style="margin-bottom: 0px;">
                            <div class="container-fluid">
                                <div class="row"> 
                                    <div class="col-md-12 text-center" style="margin-bottom: 15px;">
                                        <img src="rillsoft_login.png" class="mx-auto d-block img-fluid">
                                    </div>
                                    <div class="col-md-12 text-justify">
                                        <p style="font-size: 20px;">Prezado cliente,<br>
                                            Consta em nossos registros pendência no pagamento de sua mensalidade ou falta de contrato ativo. Por favor entre em contato conosco para regularização do seu sistema o mais breve possível.<br>
                                            Nosso horário de atendimento é de segunda à sexta-feira das 08:00 às 12:00 e das 14:00 às 18:00.<br>
                                        </p>
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <p>
                                            <strong style="color: #666;">www.rillsoftsistemas.com.br</strong><br>
                                            (91)3263-1774 / 3295-1882<br>
                                            <span><i class="fa fa-whatsapp text-success"></i> (91)98898-8777</span>
                                        </p>
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <a href="#" class="btn btn-success" @click.prevent="mtdlogoff()"><i class="fa fa-sign-out"></i> Sair do sistema</a>
                                    </div>                                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
        
        
        <!-- Chat atendimento -->
        <div id="dvchat" class="border" style="display: none;">
            <div id="dvtitulochat" class="text-center">
                <button type="button" class="close" aria-label="Close" @click.prevent="rtfinalizachat()" style="z-index: 99;">
                    <span aria-hidden="true">&times;</span>
                </button>
                <button id="btnavaliacao" type="button" class="btn btn-primary btn-sm" data-toggle="tooltip" title="Avaliar atendimento" @click.prevent="rtchamaravaliacao()"><i class="fa fa-star-half-full"></i></button>
                <h5>Atendimento</h5>
            </div>
            <div id="dvconteudochat">
                <div id="dvidentificacao" class="row">
                    <div class="col-md-12 text-left">
                        <label for="ednomechat"><strong>Apresente-se</strong></label>
                        <input type="text" class="form-control form-control-sm" id="ednomechat" v-model="cnomechat" data-bv-group=".group" maxlength="20" placeholder="Nome"/>
                    </div>
                    <div class="col-md-12 text-left">
                        <label for="edemailchat"><strong>E-mail</strong></label>
                        <input type="email" class="form-control form-control-sm" id="edemailchat" v-model="cemailchat" data-bv-group=".group" maxlength="100" placeholder="E-mail"/>
                    </div>
                    <div class="col-md-12 text-left">
                        <label for="edtelefonechat"><strong>Nr. telefone</strong></label>
                        <input type="text" class="form-control form-control-sm" id="edtelefonechat" v-model="cfonechat" data-bv-group=".group" maxlength="20" placeholder="Telefone"/>
                    </div>
                    <div class="col-md-12 text-left">
                        <label for="txtmsginicialchat"><strong>Mensagem</strong></label>
                        <textarea class="form-control center" rows="2" id="txtmsginicialchat" v-model="cmsgchat"></textarea>
                    </div>
                </div>
                <!--Rotina de leitura e envio de mensagens-->
                <div id="dvmsgschat" class="row">
                    <ul>
                        <li v-for="msg in lstmsgschat">
                            <div v-if="parseInt(msg.origem) === 0" class="conteudo">
                                <i class="fa fa-user-circle" aria-hidden="true"></i>
                                <p class="nomeindicador">{{rtprimeirasmaiusculas(msg.nomechat)}}</p>
                                <p class="corpomsg">{{msg.msg}}</p>
                                <span class="time-right">{{msg.dthrmsg.substring(11,16)}}</span>
                            </div>
                            <div v-else-if="parseInt(msg.origem) === 1" class="conteudo darker">
                                <i class="fa fa-desktop" aria-hidden="true"></i>
                                <p class="nomeindicador">{{rtprimeirasmaiusculas(msg.nometecnico)}}</p>
                                <p class="corpomsg">{{msg.msg}}</p>
                                <span class="time-left">{{msg.dthrmsg.substring(11,16)}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <!---->
                <div id="dvrodapechat" class="row border-top">
                    <div id="dvbtiniciarchat" class="col-md-12 text-center">
                        <button type="button" class="btn btn-primary btn-sm" id="btinichat" style="width: 100%;" @click.prevent="rtiniciarchat()">Iniciar chat</button>
                    </div>
                    <div id="dvmsgenviar">
                        <div id="dvstatus">
                            <p id="pstatus">{{ cstatus }}</p>
                        </div>
                        <textarea class="form-control center" rows="2" id="txtmsgchat" v-model="cmsgchatenviar"></textarea>
                        <button type="button" id="btenviarmsgchat" class="btn btn-primary" @click.prevent="rtenviarmsgchat()"><i class="fa fa-paper-plane"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Final tela chat -->
        <!-- Avaliação do atendimento-->
        <div class="modal fade" id="mdavaliaratendimento">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Avaliação do atendimento</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-12" style="margin-bottom: 10px;">
                                <label for="txtcomentario"><strong>Comente como foi o atendimento:</strong></label>
                                <textarea class="form-control center" rows="4" id="txtcomentario" v-model="vtxtcomentario"></textarea>
                            </div>
                            <div class="col-lg-12 text-center">
                                <h5 style="font-size: 14px;"><strong>Não esqueça de dar nossa nota!<br>Isso é muito importante para melhorar nosso atendimento.</strong></h5>
                            </div>
                            <div class="col-sm-12 text-center">
                                <span v-if="vavaliacao < 1"><i class="fa fa-star-o starclear"  @click.prevent="rtposavalicao(1)"></i></span>
                                <span v-else><i class="fa fa-star starfilled"  @click.prevent="rtposavalicao(1)"></i></span>

                                <span v-if="vavaliacao < 2"><i class="fa fa-star-o starclear"  @click.prevent="rtposavalicao(2)"></i></span>
                                <span v-else><i class="fa fa-star starfilled"  @click.prevent="rtposavalicao(2)"></i></span>

                                <span v-if="vavaliacao < 3"><i class="fa fa-star-o starclear"  @click.prevent="rtposavalicao(3)"></i></span>
                                <span v-else><i class="fa fa-star starfilled"  @click.prevent="rtposavalicao(3)"></i></span>

                                <span v-if="vavaliacao < 4"><i class="fa fa-star-o starclear"  @click.prevent="rtposavalicao(4)"></i></span>
                                <span v-else><i class="fa fa-star starfilled"  @click.prevent="rtposavalicao(4)"></i></span>

                                <span v-if="vavaliacao < 5"><i class="fa fa-star-o starclear"  @click.prevent="rtposavalicao(5)"></i></span>
                                <span v-else><i class="fa fa-star starfilled"  @click.prevent="rtposavalicao(5)"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click.prevent="rtchamarconfirmacaoavaliacao()">Confirmar</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Final avaliação do atendimento-->


        <!-- modal para as notificações caso esteja em layout pequeno -->
        <div class="modal fade" id="mdnotificacoesmini" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body" style="padding: 0;">
                        <div class="container-fluid" style="padding: 0px; width: 100%;">
                            <ul class="list-group" style="width: 100%;">
                                <li class="list-group-item active">
                                    <i class="fa fa-bell"></i> Notificações
                                    <span id="limpar-notificacao" data-dismiss="modal" @click.prevent="mtdlimparnotificacoes(0)">Limpar tudo</span>
                                </li>
                                <div style="max-height: 273px; overflow: auto;">
                                    <li v-for="(notificacao, indice) in lstnotificacoes" :key="indice" data-dismiss="modal" @click.prevent="mtddetalhesnotificacao(notificacao)" class="list-group-item list-group-item-action" style="padding-bottom: 20px; cursor: pointer;">
                                        <template v-if="parseInt(notificacao.tipo) === 1">
                                            <span><i class="fa fa-certificate" style="font-size: 22px; color: #f82b54;"></i></span>
                                        </template> 
                                        <template v-else-if="parseInt(notificacao.tipo) === 10">
                                            <span><i class="fa fa-flag" style="font-size: 22px; color: #2ba9f8;"></i></span>
                                        </template>                                            
                                        <template v-else>
                                            <img  v-bind:src="pathfotos+notificacao.foto" class="img-usutarefa img-usuario-notificacao" data-toggle="tooltip" v-bind:title="'Registrada por: '+notificacao.nomeusu">
                                        </template>
                                        <span class="tit-notificacao" v-bind:title="notificacao.descnotificacao">{{ notificacao.descnotificacao }}</span>
                                        <span class="data-notificacao">{{ notificacao.dtemissao }}</span>
                                    </li>

                                    <li v-for="(titulo, indice) in lstBoletosDisp" :key="indice" class="list-group-item list-group-item-action" style="padding-bottom: 20px;">
                                        <span v-if="parseInt(titulo.statusapi)!==1" title="Pagar via RillPay" >
                                            <svg @click.prevent="mtdpagamentopix(titulo)" 
                                                xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="13.3247mm" height="6.649mm" version="1.1" 
                                                style="margin-top: 5px; cursor: pointer; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                                                viewBox="0 0 194.64 74.7"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
                                                <g id="Camada_x0020_1">
                                                <metadata id="CorelCorpID_0Corel-Layer"/>
                                                <path class="fil0" d="M1.09 30.95l13.17 -23.61 23.17 -5.93 -20.43 38.33 -15.92 -8.79zm177.79 -7.27c0,-2.61 -0.47,-4.76 -1.39,-6.45 -0.92,-1.69 -2.06,-2.94 -3.41,-3.74 -1.35,-0.8 -2.76,-1.31 -4.23,-1.53 -1.49,-0.22 -3.02,-0.31 -4.61,-0.31l-6.47 0 0 25.29 6.82 0c2.43,0 4.45,-0.33 6.1,-0.98 1.63,-0.65 2.98,-1.57 4.02,-2.74 1.04,-1.16 1.82,-2.57 2.37,-4.2 0.53,-1.63 0.8,-3.41 0.8,-5.33zm15.76 -1.1c0,4.2 -0.65,7.88 -1.96,11.1 -1.29,3.23 -3.2,5.94 -5.71,8.14 -2.49,2.22 -5.55,3.88 -9.18,5.04 -3.63,1.16 -7.9,1.73 -12.82,1.73l-6.22 0 0 23.7c0,0.39 -0.12,0.72 -0.37,1.04 -0.26,0.29 -0.67,0.55 -1.23,0.74 -0.57,0.2 -1.33,0.33 -2.29,0.45 -0.94,0.12 -2.18,0.18 -3.65,0.18 -1.45,0 -2.67,-0.06 -3.65,-0.18 -0.98,-0.12 -1.74,-0.27 -2.31,-0.45 -0.57,-0.2 -0.98,-0.45 -1.2,-0.74 -0.23,-0.31 -0.35,-0.67 -0.35,-1.04l0 -66.88c0,-1.8 0.47,-3.16 1.41,-4.06 0.94,-0.9 2.18,-1.35 3.71,-1.35l17.53 0c1.76,0 3.45,0.06 5.04,0.2 1.59,0.14 3.49,0.43 5.73,0.86 2.22,0.45 4.47,1.25 6.75,2.45 2.27,1.18 4.23,2.69 5.84,4.51 1.61,1.82 2.84,3.94 3.69,6.39 0.84,2.43 1.25,5.16 1.25,8.18zm-81.52 -0.67c0,-2.45 -0.55,-4.53 -1.67,-6.2 -1.12,-1.69 -2.94,-2.88 -5.47,-3.57 -0.76,-0.2 -1.63,-0.33 -2.61,-0.45 -0.98,-0.12 -2.33,-0.18 -4.06,-0.18l-6.78 0 0 21.06 7.7 0c2.16,0 4.02,-0.26 5.63,-0.78 1.63,-0.51 2.96,-1.23 4.04,-2.18 1.08,-0.92 1.88,-2.06 2.41,-3.35 0.53,-1.29 0.8,-2.74 0.8,-4.35zm19.53 50.49c0,0.41 -0.08,0.77 -0.23,1.06 -0.16,0.29 -0.51,0.53 -1.08,0.72 -0.59,0.18 -1.41,0.31 -2.53,0.39 -1.12,0.08 -2.63,0.12 -4.53,0.12 -1.61,0 -2.88,-0.04 -3.84,-0.12 -0.96,-0.08 -1.73,-0.22 -2.27,-0.43 -0.55,-0.21 -0.94,-0.47 -1.18,-0.8 -0.22,-0.33 -0.41,-0.73 -0.57,-1.18l-6.71 -16.65c-0.8,-1.88 -1.59,-3.57 -2.35,-5.02 -0.77,-1.47 -1.63,-2.69 -2.57,-3.67 -0.94,-0.98 -2.04,-1.71 -3.27,-2.22 -1.22,-0.49 -2.65,-0.75 -4.25,-0.75l-4.72 0 0 28.41c0,0.37 -0.12,0.72 -0.37,1.02 -0.26,0.31 -0.67,0.57 -1.23,0.77 -0.57,0.18 -1.33,0.33 -2.29,0.45 -0.94,0.12 -2.18,0.18 -3.65,0.18 -1.45,0 -2.67,-0.06 -3.65,-0.18 -0.98,-0.12 -1.74,-0.27 -2.31,-0.45 -0.57,-0.2 -0.98,-0.45 -1.2,-0.74 -0.23,-0.31 -0.35,-0.67 -0.35,-1.04l0 -67.52c0,-1.69 0.43,-2.9 1.29,-3.65 0.86,-0.75 1.92,-1.12 3.18,-1.12l19.25 0c1.94,0 3.57,0.04 4.82,0.12 1.25,0.08 2.41,0.18 3.45,0.27 2.98,0.43 5.67,1.16 8.06,2.2 2.39,1.02 4.43,2.37 6.1,4.04 1.67,1.67 2.94,3.63 3.82,5.9 0.88,2.28 1.31,4.88 1.31,7.84 0,2.47 -0.31,4.74 -0.94,6.78 -0.65,2.06 -1.57,3.88 -2.8,5.49 -1.22,1.61 -2.73,3 -4.53,4.18 -1.8,1.2 -3.86,2.14 -6.16,2.88 1.12,0.53 2.16,1.18 3.14,1.94 0.98,0.77 1.9,1.71 2.76,2.8 0.86,1.1 1.69,2.33 2.45,3.75 0.77,1.39 1.51,2.98 2.24,4.74l6.29 14.68c0.57,1.45 0.96,2.51 1.14,3.2 0.2,0.67 0.29,1.2 0.29,1.59zm-62.42 -27.59l-13.19 23.6 -23.17 5.92 20.44 -38.31 15.92 8.79z"/>
                                                <path class="fil1" d="M29.19 72.89l-23.49 -13.4 -5.71 -23.22 38.13 20.78 -8.93 15.84zm13.5 -69.69l23.37 13.6 5.51 23.27 -37.95 -21.11 9.07 -15.76z"/>
                                                </g>
                                            </svg>
                                        </span>
                                        <span v-else><i class="fa fa-barcode" style="font-size: 22px; color: #0acf97; margin-top: 10px;  cursor: pointer;" data-dismiss="modal" @click.prevent="mtdimprimirboleto(titulo)" title="Pagar via boleto"></i></span>
                                        <span class="tit-notificacao"  style="left: 81px;">Fatura disponível</span>
                                        <span class="data-notificacao" style="left: 81px;">Vencimento: {{ titulo.dtventit }}</span>
                                    </li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>
<script>
    import util from '../utilitarios/util.js'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import centralnotificacao from '../components/cmpcentralnotificacao.vue';
    import whatsnew from '../components/cmpwhatsnew.vue';
    export default {
        name: "menutop",
        components:{
            VueBootstrap4Table,
            centralnotificacao,
            whatsnew
        },        
        data: function () {
            return {
                pathfotos           : this.$store.state.configpaths.pathimagens,
                lstpesquisa         : [],
                lstlistaresultado   : [],
                qtdnotificacoes     : 0,
                qtdatzs             : 0,   
                lstnotificacoes     : [],
                detnotificacao      : [],
                lstitenscoletor     : [],
                menuapp             : [],
                menuindividual      : [],
                pathfotovisualizar  : this.$store.state.configpaths.pathimagens,
                vcontpesqrapida     : '',

                //variáveis de liberação do sistema
                lstBoletosDisp      : [],
                diasatraso          : 0,

                //alterações de senha e foto do usuário                
                asenha_antiga       : '',
                asenha_nova         : '',
                asenha_repete       : '',
                arqimgselecionado   : '',
                vfoto               : '',

                //variaveis do coletor
                itemalteracaocoletor: [],
                qtditemalteracaocoletor: 0,


                //exibicaocard      : this.$store.state.usuario.exibicaocard == 1 ? true : false,


                //Variáveis do chat
                vtimeoutId      : '',
                vcodcli         : 0,
                vdadoschat      : [],
                lstmsgschat     : [],
                cstatus         : 'Aguarde o atendimento...',
                cnomechat       : this.$store.state.usuario.nome,
                cemailchat      : '',
                cfonechat       : '',
                cmsgchat        : '',
                cmsgchatenviar  : '',
                qtdmsg           : 0,
                qtdmsgold        : 0,
                //variaveis de avaliacao
                vavaliacao     : 0,
                vtxtcomentario : '',

                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "slot_idproduto",
                        row_classes: "def-col-idproduto",
                        row_text_alignment: "text-right",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Qtd",
                        name: "qtd",
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Data/Hora",
                        name: "dthrinclusao",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }                
            };
        },
        methods: {
            mtdmudarexibicaocard(){
                let vself = this;
                    
                let parametros      = [
                    {parametro: 'op',           valor : 'mudarexibicaocard'},
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'idusuario',    valor : window.localStorage.getItem('idusuario')},
                    {parametro: 'exibicaocard', valor : vself.exibicaocard ? 0 : 1},
                ];
                let retorno     = util.reqaxios(parametros, 'post', window.localStorage.getItem('adrsrv')+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    if($.isNumeric(response.data)){

                        let payload = vself.$store.state.usuario;

                        payload.exibicaocard = vself.exibicaocard ? 0 : 1;
                        vself.$store.commit('MUDAR_USUARIO_LOGADO', payload);
                        window.localStorage.setItem('exibicaocard', vself.exibicaocard ? 1 : 0);
                        vself.$toastr.s("Exibição de cards alterada com sucesso!", 'Sucesso!');
                        
                    }else{
                        vself.$toastr.w(response.data + " Favor tentar novamente mais tarde!", 'Atenção!');
                    }   
                }).catch(function (response) {
          
                });	
                
            },
            mtdopennotificacoesmini(){
                if(this.qtdnotificacoes > 0){
                    $('#mdnotificacoesmini').modal('show');
                }
            },
            dragElement(elmnt) {
                let pos1 = 0,
                    pos2 = 0,
                    pos3 = 0,
                    pos4 = 0;

                const dragMouseDown = (e) => {
                    e = e || window.event;
                    e.preventDefault();

                    pos3 = e.clientX;
                    pos4 = e.clientY;
                    document.onmouseup = closeDragElement;
                    document.onmousemove = elementDrag;
                };

                const elementDrag = (e) => {
                    e = e || window.event;
                    e.preventDefault();

                    pos1 = pos3 - e.clientX;
                    pos2 = pos4 - e.clientY;
                    pos3 = e.clientX;
                    pos4 = e.clientY;

                    elmnt.style.top = elmnt.offsetTop - pos2 + "px";
                    elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
                };

                const closeDragElement = () => {
                    document.onmouseup = null;
                    document.onmousemove = null;
                };

                if (document.getElementById("dvtitulochat")) {

                    document.getElementById("dvtitulochat").onmousedown = dragMouseDown;
                } else {
                    elmnt.onmousedown = dragMouseDown;
                }
            },

            rtprimeirasmaiusculas(str) {
                return util.titleize(str);
            },
            rtlistarmsgschat(){
                let vself = this;
            

                        
                let parametros  = [
                    {parametro: 'op',             valor : 'carregarmsgs'},
                    {parametro: 'idchat',         valor :  this.vdadoschat.idchat},
                ];
        
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/funcoeschat.php');
                retorno.then(function (response) {
                    
                   vself.lstmsgschat = response.data

                   if (parseInt(vself.qtdmsg) !== parseInt(vself.qtdmsgold)) {
             
                        setTimeout(function () {
                            $("#dvmsgschat").animate({scrollTop: $('#dvmsgschat').prop("scrollHeight") + 200}, 300);
                        }, 500);
                    }
                    if (vself.rtcontadormsg(vself.lstmsgschat, 2) > 0){
                        if (!$('#mdavaliaratendimento').is(':visible')) {
                            vself.rtchamaravaliacao();
                        }
                    }

                }).catch(function (response) {
                });	
            },
            rtcontadormsg(lstmsg, origem) {
                var qtd = 0;
                if (lstmsg) {
                    for (var i = 0; i < lstmsg.length; i++) {
                        if (parseInt(lstmsg[i]['origem']) == parseInt(origem)){
                            qtd++;
                        }
                    }
                }
                return qtd;
            },
            rtfinalizachat() {
                let self = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: "Deseja mesmo encerrar o chat?",
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $(".btn-blue").prop("disabled", true);
                                $("#dvchat").toggle(500);
                                window.localStorage.removeItem("dadoschat");
                                $('#dvmsgschat').hide();
                                $('#dvmsgenviar').hide();
                                $('#btnavaliacao').hide();
                                clearTimeout(self.vtimeoutId);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $("#btgravar").focus();
                            }
                        }
                    }
                });
            },
            rtchat() {
                if (!$('#dvchat').is(':visible')) {
                    this.cnomechat  = this.$store.state.usuario.nome;
                    this.cemailchat = '';
                    this.cfonechat  = '';
                    this.cmsgchat   = '';
                    $('#dvmsgschat').hide();
                    $('#dvmsgenviar').hide();
                    $('#btnavaliacao').hide();
                    $('#dvidentificacao').show();
                    $('#dvbtiniciarchat').show();
                    $('#btinichat').attr('disabled', false);
                    $("#dvchat").toggle(500);
                    $("#ednomechat").focus();
                }
            },
            rtiniciarchat() {
                let vself = this;

                
                

                if (this.cnomechat === '') {
                    this.$toastr.w('Nome deve ser informado!', 'Atenção!');
                    $('#ednomechat').focus();
                    return;
                }
                if (this.cfonechat === '') {
                    this.$toastr.w('Telefone deve ser informado!', 'Atenção!');
                    $('#edtelefonechat').focus();
                    return;
                }
                if (this.cemailchat === '') {
                    this.$toastr.w('E-mail deve ser informado!', 'Atenção!');
                    $('#edemailchat').focus();
                    return;
                }
                if (this.cmsgchat === '') {
                    this.$toastr.w('Mensagem deve ser informada!', 'Atenção!');
                    $('#txtmsginicialchat').focus();
                    return;
                }
                if (!util.isValidEmailAddress(this.cemailchat)) {
                    this.$toastr.w('E-mail inválido!', 'Atenção!');
                    $('#edemailchat').focus();
                    return;
                }

                $('#btinichat').attr('disabled', true);

                this.vdadoschat = {
                    'codcli'      : vself.$store.state.filialpadrao.idcliente,
                    'nomechat'    : this.cnomechat,
                    'fonechat'    : this.cfonechat,
                    'emailchat'   : this.cemailchat,
                    'msgchat'     : this.cmsgchat
                };

                        
                let parametros  = [
                    {parametro: 'op',             valor : 'iniciarchat'},
                    {parametro: 'dadoschat',      valor :  JSON.stringify(this.vdadoschat)},
                ];
        
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/funcoeschat.php');
                retorno.then(function (response) {
                    if (parseInt(response.data.idchat) > 0) {
                        
                        vself.vdadoschat.idchat = response.data.idchat;
                        vself.lstmsgschat       = response.data.msgschat;

                        window.localStorage.setItem('dadoschat', JSON.stringify(vself.vdadoschat));


                        $('#dvidentificacao').hide();
                        $('#dvbtiniciarchat').hide();
                        $('#dvmsgschat').hide();
                        $('#dvmsgenviar').hide();

                        $('#btnavaliacao').show();

                        $('#dvmsgschat').show();
                        $('#dvmsgenviar').show();
                        vself.lstmsgschat       = [];
                        vself.rtlistarmsgschat();
                        vself.rtverificamsgchat();
                    } else {
                        vself.$toastr.w(response.data + " Favor tentar novamente mais tarde!", 'Atenção!');
                        $('#btinichat').attr('disabled', false);
                    }
                }).catch(function (response) {
                });	

            },
            rtverificachatativo(){
                if (window.localStorage.getItem("dadoschat") != null){
                    this.vdadoschat = JSON.parse(window.localStorage.getItem("dadoschat"));
                    this.rtlistarmsgschat();
                    $('#dvidentificacao').hide();
                    $('#dvbtiniciarchat').hide();

                    $('#dvmsgschat').show();
                    $('#dvmsgenviar').show();
                    $("#dvchat").toggle(500);
                    $('#txtmsgchat').focus();
                    this.rtverificamsgchat();
                    $('#btnavaliacao').show();
                }else{
                    this.vdadoschat = [];
                    $('#btnavaliacao').hide();
                }
            },
            rtverificamsgchat() {
                this.qtdmsgold    = this.rtcontadormsg(this.lstmsgschat, 1);
                var v = this;
                this.vtimeoutId = setTimeout(function () {
                    v.rtlistarmsgschat();
                    v.rtverificamsgchat();
                }, 2000);
            },
            rtposavalicao(vpos) {
                if (parseInt(vpos) === parseInt(this.vavaliacao)){
                    this.vavaliacao--;
                }else{
                    this.vavaliacao = vpos;
                }
            },
            rtchamaravaliacao() {
                this.vavaliacao     = 0;
                this.vtxtcomentario = '';
                $("#mdavaliaratendimento").modal('show');
            },
            rtchamarconfirmacaoavaliacao() {
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: "Confirma informações da avaliação do atendimento?",
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $(".btn-blue").prop("disabled", true);


                   

                                let  vdadosavaliacao = {
                                    'idchat'      : vself.vdadoschat.idchat,
                                    'txtavaliacao': vself.vtxtcomentario,
                                    'avaliacao'   : vself.vavaliacao
                                };
                        
                                let parametros  = [
                                    {parametro: 'op',             valor : 'avaliarchat'},
                                    {parametro: 'dadosavaliacao', valor :  JSON.stringify(vdadosavaliacao)},
                                ];
                        
                                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/funcoeschat.php');
                                retorno.then(function (response) {

                                    console.log('aqui')
                                    
                                    if ($.isNumeric(response.data)) {
                                        $("#mdavaliaratendimento").modal('hide');
                                        $("#dvchat").toggle(500);
                                        window.localStorage.removeItem("dadoschat");
                                        $('#dvmsgschat').hide();
                                        $('#dvmsgenviar').hide();
                                        clearTimeout(vself.vtimeoutId);
                                    } else {
                                        vself.$toastr.w(response.data + " Favor tentar novamente mais tarde!", 'Atenção!');
                                    }
                                }).catch(function (response) {
                                });	   
                            
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $("#btgravar").focus();
                            }
                        }
                    }
                });
            },
            rtenviarmsgchat() {
                if (this.cmsgchatenviar.trim() !== '') {

                    let vself = this;

                    let vinfomsg = {
                        'idchat' : this.vdadoschat.idchat,
                        'msgchat': this.cmsgchatenviar,
                        'origem' : 0
                    };
              
                    let parametros  = [
                        {parametro: 'op',           valor : 'enviarmsgchat'},
                        {parametro: 'infomsg',      valor :  JSON.stringify(vinfomsg)},
                    ];
            
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/funcoeschat.php');
                    retorno.then(function (response) {
                        
                        if ($.isNumeric(response.data)) {
                            vself.rtlistarmsgschat();
                            vself.cmsgchatenviar = '';
                            $('#txtmsgchat').focus();
                            setTimeout(function () {
                                $("#dvmsgschat").animate({scrollTop: $('#dvmsgschat').prop("scrollHeight") + 200}, 300);
                            }, 200);
                        } else {
                            vself.$toastr.w(response.data + " Favor tentar novamente mais tarde!", 'Atenção!');
                        }
                    }).catch(function (response) {
                    });	                   
                }
            },
            mtdatualizaqtdatz(){
                let vself = this;
              
                let parametros  = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'param1',       valor : 'atzqtdatz'},
                ];
        
                let retorno           = util.reqaxios(parametros, 'post', 'rillsoft.app/sacweb/controller/rotinanewsatz.php');
                retorno.then(function (response) {
                    
                    vself.qtdatzs  = response.data;
                }).catch(function (response) {

          
                });				
            },
            mtdwhatsnew(){
                if(parseInt(this.qtdatzs) > 0){
                    $('#mdo_que_ha_denovo').modal('show');
                } 
            },
            mtdversaodisponivel(op){
                return util.verificaplano(op, this.$store.state.filialpadrao.plnc);
            },
            primeiramaiuscula(texto){
                return util.primeiramaiuscula(texto);
            },
            mtdlogoff() {
                util.logoff(this);
            },
            rtcarregardadosusuario() {
                let vself           = this;

                vself.pathfotovisualizar  = vself.$store.state.configpaths.pathimagens;
                vself.pathfotos           = vself.$store.state.configpaths.pathimagens;
                
                let loader          = vself.$loading.show();

                let parametros      = [
                    {parametro: 'op',           valor : 'dadosusuario'},
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'idusuario',    valor : window.localStorage.getItem('idusuario')}
                ];
                let retorno     = util.reqaxios(parametros, 'post', window.localStorage.getItem('adrsrv')+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    //carrega os dados da filial padrão do usuário
                    let payloadf = {
                        idcliente         : window.localStorage.getItem('idcliente'),//id do cliente no sac
                        idclientepadrao   : response.data.filialpadrao.idcliente,//id do consumidor padrao para emissao dos pedidos
                        codfil            : response.data.filialpadrao.codfil,
                        descfil           : response.data.filialpadrao.descfil,
                        fantasia          : response.data.filialpadrao.fantasia,
                        formulacustopro   : response.data.filialpadrao.formulacustoproduto,
                        logo              : response.data.filialpadrao.logo,
                        idestoque         : response.data.filialpadrao.idestoque,
                        descestoque       : response.data.filialpadrao.descestoque,
                        nomecliente       : response.data.filialpadrao.nomecliente,
                        idplano           : response.data.filialpadrao.idplano,
                        tipoplano         : response.data.filialpadrao.tipoplano,
                        descplano         : response.data.filialpadrao.descplano,
                        idtabela          : response.data.filialpadrao.idtabela,
                        percentrada       : response.data.filialpadrao.percentrada,
                        permitedesconto   : response.data.filialpadrao.permitedesconto,
                        defvendedorcliente: response.data.filialpadrao.defvendedorcliente,
                        plnc              : response.data.plnc,
                        entregaauto       : response.data.filialpadrao.entregaauto,  
                        reservaauto       : response.data.filialpadrao.reservaauto,
                        produtosporfilial : response.data.filialpadrao.produtosporfilial  
                    };
                    
                    vself.$store.commit('MUDAR_DADOS_FILIAL',payloadf);


                    //Monta o menu do usuário
                    vself.menuapp           = [];
                    vself.menuindividual    = [];
                    vself.menuapp           = response.data.perfilusu;
                    vself.lstnotificacoes   = response.data.notificacoes;
                    vself.lstitenscoletor   = response.data.itenscoletor;                   
                    vself.qtdnotificacoes   = vself.lstnotificacoes.length;
                    vself.qtdatzs           = parseInt(response.data.qtdatzs);
                    vself.$store.commit('MUDAR_PERFIL_USUARIO',vself.menuapp);

                    //console.log(vself.menuapp);

                    for (var i = 0; i < vself.menuapp.length; i++) {
                        var m = vself.menuapp[i]['codop'];
                        var f = m.indexOf(".");
                        if (f === -1) {
                            let menutmp = {
                                codop   : vself.menuapp[i]['codop'],
                                menu    : vself.menuapp[i]['descricao'],
                                habilita: vself.menuapp[i]['habilita'],
                                chave   : vself.menuapp[i]['chave'],
                                icone   : vself.menuapp[i]['icone'],
                                submenu : []
                            };
                            vself.menuindividual.push(menutmp);
                        }
                    }
                    let indtres = 0
                    try {
                        for (var i = 0; i < vself.menuapp.length; i++) {
                        var m = vself.menuapp[i]['codop'];
                        var f = m.split(".");
                        if (f.length === 2) {
                            var p     = m.indexOf(".");
                            var codop = m.substring(0, p);
                            let menuitem  = {
                                menu    : vself.menuapp[i]['descricao'],
                                link    : vself.menuapp[i]['link'],
                                habilita: vself.menuapp[i]['habilita'],
                                codop   : vself.menuapp[i]['codop']
                            };
                            var ind = util.getArrayIndexForKey(vself.menuindividual, 'codop', codop);
                          
                            indtres = codop
                            
                            vself.menuindividual[ind]['submenu'].push(menuitem);
                        }
                    }
                        
                    } catch (error) {
                        console.log(indtres);
                    }
                    
                    
                }).catch(function (response) {
                    loader.hide();
                    console.log(response);
                });
            },
            openNav(){
                $("#navbarmenu").removeClass("fixed-top");
                $("#dvconteudoapp").css("margin-top", "16px");
                // $("#dvalertasistema").css("margin-top", "11px");
                // $("#dvalertasistema").css("margin-bottom", "25px");
                document.getElementById("mySidenav").style.width = "250px";
                $('#dvconteudo-side-nav').fadeIn(700);
                this.mtdmontalstpesq();
                setTimeout(function(){
                    $('#edpesquisamenu').focus();
                },200);
            },
            closeNav(){
                $('#dvconteudo-side-nav').hide();
                document.getElementById("mySidenav").style.width = "0";
                setTimeout(function(){
                    $("#navbarmenu").addClass("fixed-top");
                    $("#dvconteudoapp").css("margin-top", "70px");
                    // $("#dvalertasistema").css("margin-top", "65px");
                    // $("#dvalertasistema").css("margin-bottom", "-60px");
                }, 500);                
            },
            mtdmontalstpesq(){
                this.vcontpesqrapida     = '';
                this.lstpesquisa         = [];
                this.lstlistaresultado   = [];
                for (var i = 0; i < this.menuapp.length; i++) {
                    let chavetmp = [];
                    if (this.menuapp[i]['chave'] !== '') {
                        chavetmp = JSON.parse(this.menuapp[i]['chave']);                        
                        if (chavetmp.length > 0) {
                            for (var x = 0; x < chavetmp.length; x++) {
                                let item = {
                                    'chave': chavetmp[x],
                                    'menu': this.menuapp[i]['descricao'],
                                    'link': this.menuapp[i]['link'],
                                    'habilita': this.menuapp[i]['habilita']
                                };
                                if (item.habilita) {
                                    this.lstpesquisa.push(item);
                                }
                            }
                        }
                    }
                }
            },
            mtddetalhesnotificacao(notificacao) {
                this.detnotificacao = notificacao;

                if(parseInt(this.detnotificacao.tipo)===3){
                    $('#mdldetnotificacaouser').modal('show');
                    var divconteudo = document.getElementById("conteudonotifexp");
                    divconteudo.innerHTML = "";
                    divconteudo.innerHTML = this.detnotificacao.conteudonotificacao;
                   
                }else{
                    $('#mdldetnotificacao').modal('show');
                }
          
            },            
            mtdlimparnotificacoes(idnotificacao){//se for 0 marca todas como lida
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'notificacaolida'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'idnotificacao',valor : idnotificacao}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();                    
                    if ($.isNumeric(response.data)){
                        if (parseInt(idnotificacao) === 0){
                            vself.lstnotificacoes = [];
                        }else{
                            vself.lstnotificacoes.splice(util.getArrayIndexForKey(vself.lstnotificacoes, 'idnotificacao', idnotificacao), 1);
                        }
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.qtdnotificacoes= vself.lstnotificacoes.length + vself.lstBoletosDisp.length;
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtddefinicoesusuario(){
                this.closeNav();
                this.asenha_antiga       = '';
                this.asenha_nova         = '';
                this.asenha_repete       = '';                
                $('#mddefinicoesusuario').modal('show');
            },
            mtdalterarsenhausuario(){
                let vself = this;
                if (vself.asenha_antiga === ''){
                    this.$toastr.w('Informe sua senha antiga!', 'Atenção!');
                    $('#edsenhaantigadef').focus();
                    return;
                }  
                if (vself.asenha_nova === ''){
                    this.$toastr.w('Informe sua nova senha!', 'Atenção!');
                    $('#edsenhanovadef').focus();
                    return;
                }                              
                if (vself.asenha_nova !== vself.asenha_repete){
                    this.$toastr.w('Senha e senha de confirmação não conferem!', 'Atenção!');
                    $('#edsenhaconfirmadef').focus();
                    return;
                }
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                    {parametro: 'op',           valor : 'defusuario'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'pwold',        valor : vself.asenha_antiga},
                    {parametro: 'pwnew',        valor : vself.asenha_nova}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Senha alterada com sucesso!', 'Informação!');
                        $('#mddefinicoesusuario').modal('hide');
                        util.logoff(vself);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                $('#edsenhaantigadef').focus();
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                 
            }, 
            mtdselecionarimagemusuariodef(event){                
                let vself       = this;                 
                vself.arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = vself.$store.state.configpaths.pathimgusuarios + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretorioimagem;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.vfoto                = localsalvar+'/'+vself.arqimgselecionado.name;                        
                        vself.arqimgselecionado    = null;
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        $('#ipselecionarimgusuariodef').val('');

                        let loaderx = vself.$loading.show();
                        let parametros      = [
                            {parametro: 'idclientesac', valor : window.localStorage.getItem('idcliente')},
                            {parametro: 'op',           valor : 'atzfoto'},
                            {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                            {parametro: 'foto',         valor : vself.vfoto}
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                        retorno.then(function (response) {
                            loaderx.hide();
                            if (!$.isNumeric(response.data)){
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                            }else{
                                $('#mddefinicoesusuario').modal('hide');
                                util.logoff(vself);                             
                            }
                        }).catch(function (response) {
                            loaderx.hide();
                            vself.$toastr.e('Erro ao enviar foto. Descrição do erro: '+response.message, 'Erro!');
                        });
                    }else{
                        loader.hide();
                        vself.vfoto             = '';                        
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimgusuariodef').val('');
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }                   
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                    vself.vfoto             = '';                        
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimgusuariodef').val('');
                });                
            },
            mtdrotinascoletor(){
                if (this.lstitenscoletor.length > 0){
                    $('#mdlcoletor').modal('show');
                }
            },
            mtdcentralnotificacao(){
                $('#mdcentralntificacao').modal('show');
            },
            mtdalteraritemcoletor(item){
                this.itemalteracaocoletor    = item;
                this.qtditemalteracaocoletor = item.qtd;
                $('#mdleditaitemcoletor').modal('show');
            },
            mtdlimparcoletor(){                
               util.rotinacoletor(this, [], 4, this.mtdlistaritenscoletor, this.$store.state.usuario.adrsrv);                
            },
            mtdrotinaitemcoletor(produto, op, qtd){
                if (parseInt(op) === 5){
                    if (parseFloat(qtd) <= 0){
                        this.$toastr.w('Quantidade inválida!', 'Atenção!');
                        $('#edqtdcoletor').focus();
                        return;
                    }                    
                    if (parseInt(produto.fracionado) === 0){
                        if (!Number.isInteger(qtd)){
                            this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                            $('#edqtdcoletor').focus();
                            return;
                        }
                    }
                    $('#mdleditaitemcoletor').modal('hide');                    
                }
                let item = {
					'idproduto'             : produto.idproduto,
                    'qtd'                   : qtd
				};
                util.rotinacoletor(this, item, op, this.mtdlistaritenscoletor, this.$store.state.usuario.adrsrv);
            },            
            mtdlistaritenscoletor(itens){                
                if (itens.length === 0){
                  $('#mdlcoletor').modal('hide');  
                }                                             
                util.atzitenscoletor(this, itens, true);   
            },
            mtdverificaliberacaosistema(){
                let vself  = this; 
                let idclisac = vself.$store.state.filialpadrao.idcliente !== null ? vself.$store.state.filialpadrao.idcliente : window.localStorage.getItem('idcliente');
                if (idclisac !== null){            
                    let loader = vself.$loading.show();
                    let parametros      = [
                        {parametro: 'op',           valor : 'boletodisponivel'},
                        {parametro: 'idcliente',    valor : idclisac}//id do cliente no sac
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.lstBoletosDisp = response.data.boletos;
                        vself.diasatraso     = response.data.diasatraso;

                        vself.qtdnotificacoes= vself.lstnotificacoes.length + vself.lstBoletosDisp.length;

                        //verifica se o cliente tem um contrato ativo                    
                        let contratoativo    = response.data.contratoativo;
                        if (parseInt(vself.diasatraso) > 5 || parseInt(contratoativo) === 0){
                            $('#mdlregularizar').modal('show');
                            return;
                        }
                        if (parseInt(vself.$store.state.usuario.receberinfsistema) === 1) {
                            if(parseInt(vself.diasatraso) > 1){
                                //$('#dvalertasistema').show();
                                vself.$swal.fire({
                                                    position: 'bottom-end',
                                                    //icon: 'success',
                                                    title: 'Atenção!',
                                                    html: 'Prezado cliente. Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para evitar suspensão dos serviços. Caso já tenha regularizado, favor desconsiderar.',
                                                    showConfirmButton: false,
                                                    showCloseButton: true,
                                                    backdrop: false                                                
                                                });
                                //Toast.fire("Dados cadastrados com sucesso", "", "success");
                            }
                        }
                        util.atzverificalib(vself, false);                                        
                    }).catch(function (response) {
                        vself.lstBoletosDisp = [];
                        vself.diasatraso     = 0;                    
                        vself.qtdnotificacoes= vself.lstnotificacoes.length + vself.lstBoletosDisp.length;
                        loader.hide();
                        util.atzverificalib(vself, false);                                        
                        console.log(response);                    
                    });                
                }
            },
            mtdimprimirboleto(titulo){
                window.open('https://rillsoft.app/sacweb/controller/rotinacobrancabancaria.php?op=gerarboleto&codtit='+titulo.codtit+'&codcli='+titulo.codcli, '_blank');
            },
            mtdpagamentopix(titulo){
                window.open(`https://rillsoft.app/acessar?cnpjcpf=${titulo.cpfcnpjcli}&acesso=${titulo.chaveacessorillpay}`, '_blank'); 
                // window.open('https://rillsoft.app/sacweb/controller/fatqrcode.php?codtit='+titulo.codtit+'&codcli='+titulo.codcli, '_blank'); 
            }
        },
        mounted: function () { 
            let vself = this;       
            vself.pathfotos  = vself.$store.state.configpaths.pathimagens;
            $('#mdldetnotificacao').on('hidden.bs.modal', function () {
                vself.mtdlimparnotificacoes(vself.detnotificacao.idnotificacao);
            }); 
            $('#mdldetnotificacaouser').on('hidden.bs.modal', function () {
                vself.mtdlimparnotificacoes(vself.detnotificacao.idnotificacao);
            }); 
            $('#mdo_que_ha_denovo').on('hidden.bs.modal', function () {
                vself.mtdatualizaqtdatz();
            }); 
            $('#mddefinicoesusuario').on('shown.bs.modal', function () {
                $('#edsenhaantigadef').focus();
            }); 
            $('#mdleditaitemcoletor').on('shown.bs.modal', function () {
                $('#edqtdcoletor').focus();
            });

            this.dragElement(document.getElementById("dvchat"));

            this.rtverificachatativo();
        },
        computed: {
            filial() {
                return this.$store.state.filialpadrao;
            },
            usuario(){
                this.rtcarregardadosusuario();                        
                return this.$store.state.usuario;                               
            },
            situacaosidenav(){             
                return this.$store.state.sidenav.fechar;                
            },
            atzcoletor(){
                return this.$store.state.atzcoletor.atualizar;
            },
            verificarlib(){
                return this.$store.state.verificalib.verificar;
            },     
            exibicaocard(){
                return this.$store.state.usuario.exibicaocard == 1 ? true : false;
            }       
        },
        watch:{
            $route(to, from) {
                if(window.localStorage.getItem("senhausu") != null){
                    if(window.localStorage.getItem("senhausu") != ""){
                        util.verificasessaolocal(this);
                    }
                }
            },
            vcontpesqrapida(val) {
                if (val.toUpperCase() !== ''){
                    this.lstlistaresultado = $.grep(this.lstpesquisa, function(element){
                        return element.chave.toUpperCase().indexOf(val.toUpperCase()) !== -1;
                    });
                }else{
                    this.lstlistaresultado = [];
                }
            },
            situacaosidenav(val){
                if (val === true){
                   this.closeNav();
					let payloads = {
						fechar    : false			
					};
					this.$store.commit('SIDE_NAV_CHANGE',payloads);                                       
                }
            },
            usuario(val){
                if (parseInt(val.definirsenhalogin) === 1){
                    this.mtddefinicoesusuario();
                }
                this.mtdverificaliberacaosistema();
            },
            atzcoletor(val){
                if (val === true){
                    this.lstitenscoletor = this.$store.state.atzcoletor.itenscoletor;
                    util.atzitenscoletor(this, this.$store.state.atzcoletor.itenscoletor, false);
                }
            },
            verificarlib(val){
                if (val === true){
                   this.mtdverificaliberacaosistema(); 
                }
            }
        }
    };
</script>
<style>
    .Azul{
        color: #4250f2;
    }
    .Amarelo{
        color: #ffbc00;
    }
    .Verde{
        color: #0acf97;
    }
    .Vermelho{
        color: #f82b54;
    }
    #mySidenav{
        background: #31353D !important;
    }
    .dv-borda-bottom{
        border-bottom: 1px solid #3a3f48;
    }
    .dados-usuario{
        padding: 15px 0 15px 0px;
    }
    #fantasia-filial{
        position: absolute;
        left: 50px;       
    }
    @media screen and (max-width: 325px) {
        #fantasia-filial{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: absolute;
            left: 50px;
            width: 160px;        
        }        
    }        
    @media screen and (max-width: 450px) {
        #fantasia-filial{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            position: absolute;
            left: 50px;
            width: 160px;        
        }        
    }
    #nome-empresa{
        width: 175px;
        text-transform: uppercase;
        font-size: 16px;
        color: #b8bfce;
        padding-bottom: 5px;;
    }
    #img-foto-usuario{
        border: 1px solid #3a3f48;
        border-radius: 5px;
        width: 50px !important;
        height: 50px !important;
    }
    #nome-usuario{
        margin-top: 5px;
        font-size: 16px;
        color: #b8bfce;
    }
    #grupo-usuario{
        margin-top: -5px;
        font-size: 12px;
        color: #b8bfce;
        font-weight: lighter;
    }    
    #grupo-lista-menu{
        cursor: pointer;
        list-style-type: none;
        padding-left: 0px;
    }
    #grupo-lista-menu>li>a{
        color: #818896; 
        font-size: 15px;               
        padding: 10px;
        padding-left: 30px;
    }    
    #grupo-lista-menu>li>a:hover{
        color: #b8bfce;
        text-shadow: 0px 0px 2px #b8bfce;
    }
    .grupo-lista-submenu{
        background: #3a3f48;
        cursor: pointer;
        list-style-type: none;
        padding-left: 55px;
    }
    .grupo-lista-submenu>li>a{
        color: #818896; 
        font-size: 15px;               
        padding: 5px;        
    }    
    .grupo-lista-submenu>li>a:hover{
        color: #1E8CBE;
        text-shadow: 0px 0px 10px #1E8CBE;        
    }     
    .grupo-lista-pesquisa{
        background: #3a3f48;
        cursor: pointer;
        list-style-type: none;
        padding-left: 5px;
        padding-right: 5px;
    }
    .grupo-lista-pesquisa>li>a{
        color: #818896; 
        font-size: 12px;               
        padding: 5px;        
    }    
    .grupo-lista-pesquisa>li>a:hover{
        color: #1E8CBE;
        text-shadow: 0px 0px 10px #1E8CBE;        
    }
    .icone-rotate{
        font-size: 10px;
        float: right;
        margin-right: 10px;
        margin-top: 5px;
        transition: 0.5s;
    }
    .grupo-lista-submenu>li>a>i{
        font-size: 8px;
        position: relative;
        top: -2px;
    }
    [data-toggle="collapse"][aria-expanded="true"] > .icone-rotate{
            -webkit-transform: rotate(90deg);
            -moz-transform: rotate(90deg);
            -ms-transform: rotate(90deg);
            -o-transform: rotate(90deg);
            transform: rotate(90deg);
            transition: 0.5s;            
    }       
    #edpesquisamenu, #btpesquisarmenu{
        background: #3a3f48;
        border-color: transparent;
        box-shadow: none;  
        color: #818896;              
    }
    .closebtn{
        cursor: pointer;
        position: absolute;
        left: 85%;
        color: #818896;
        top: -8px;
        font-size: 20px;   
    }
    .closebtn:hover{
        color: #b8bfce;
        text-shadow: 0px 0px 2px #b8bfce;        
    }
    .icone-menu{
        font-size: 18px;
        margin-right: 10px;
    }   
    #lst-icones-menu-nav{
        margin-top: -10px;
        margin-bottom: -10px;
    }
    #lst-icones-menu-nav > li{
        display: inline-block;
        margin-left: 2px;
    }
    @media (max-width: 991px) {
        #lst-icones-menu-nav{
            padding-left: 5px;
            margin-top: 0px;
            margin-bottom: -5px;
        }
    }
    .icone-menu-bar{
        color: #8f959b;
        transition: 0.2s; 
        cursor: pointer;
        font-size: 18px;
        margin-left: 20px;
    }     
    .icone-menu-bar:hover{ 
        transition: 0.2s;  
        color: #b8bfce;
        text-shadow: 0px 0px 5px #b8bfce;               
    }
    .drop-notificacoes{
        border: 0px!important;
        left: -240px!important;
        border: 0px!important;
        padding: 0px!important;
        width: 300px !important;
        top: 40px!important;        
    }
    .drop-notificacoes-mini{
        border: 0px!important;
        left: -240px!important;
        border: 0px!important;
        padding: 0px!important;
        width: 300px !important;
        top: 40px!important;        
    }
    .drop-mensagens{
        border: 0px!important;
        left: -240px!important;
        border: 0px!important;
        padding: 0px!important;
        width: 300px !important;
        top: 40px!important;        
    }
    .badge-notfusu{
        font-size: 10px!important;
        min-width: 20px;
        border-radius: 10px;
        position: absolute;
        top: -5px;
        left: 30px;
    }
    .badge-notfusu-mini{
        font-size: 10px!important;
        min-width: 20px;
        border-radius: 10px;
        position: absolute;
        top: 8px;
        left: 173px;
    }
    .badge-itens-coletor{
        background: #4250f2!important;
        font-size: 10px!important;
        min-width: 20px;
        position: absolute;
        top: 10px;
        margin-left: -5px;
    }   
    .badge-whatsnew{
        background: rgb(90, 98, 183)!important;
        font-size: 10px!important;
        min-width: 20px;
        position: absolute;
        top: 10px;
        margin-left: -5px;
    }      
    @media (min-width: 992px) {
        .animate {
            animation-duration: 0.3s;
            -webkit-animation-duration: 0.3s;
            animation-fill-mode: both;
            -webkit-animation-fill-mode: both;
        }
    }

    @keyframes slideIn {
        0% {
            transform: translateY(1rem);
            opacity: 0;
        }
        100% {
            transform:translateY(0rem);
            opacity: 1;
        }
        0% {
            transform: translateY(1rem);
            opacity: 0;
        }
    }

    @-webkit-keyframes slideIn {
        0% {
            -webkit-transform: transform;
            -webkit-opacity: 0;
        }
        100% {
            -webkit-transform: translateY(0);
            -webkit-opacity: 1;
        }
        0% {
            -webkit-transform: translateY(1rem);
            -webkit-opacity: 0;
        }
    }

    .slideIn {
    -webkit-animation-name: slideIn;
    animation-name: slideIn;
    }

.tit-notificacao{
    position: absolute;
    font-size: 15px;
    color: #6c757d;
    top: 10px;
    left: 65px;
    max-width: 220px; 
    overflow: hidden; 
    text-overflow: ellipsis; 
    white-space: nowrap;    
}
.data-notificacao{
    font-size: 10px;
    font-weight: 500;
    color: #98a6ad;
    position: absolute;
    left: 65px;
    top: 35px;  
}
.img-usuario-notificacao{
    width: 35px!important;
    height: 35px!important;
    margin-left: -5px!important;
}
.img-usuario-notificacao-esp{
    width: 20px!important;
    height: 20px!important;
    margin-left: -5px!important;
}
#limpar-notificacao{
    float: right;
    font-size: 12px;
    margin-top: 2px;
    cursor: pointer; 
    transition: 0.5s;   
}
#limpar-notificacao:hover{
    filter: brightness(80%)!important;
    transition: 0.5s;
}
#img-usuario-def{
    position: relative;
    background-color: #ddd;
    border-radius: 100%;
    height: 220px;
    object-fit: cover;
    width: 220px;
    cursor: pointer;
}
.icon-validade-cert{
    font-size: 45px;
    color: #f82b54;
}
.icon-novos-ncms{
    font-size: 45px;
    color: #2bc5f8;
}
#mdleditaitemcoletor{
    z-index: 1051!important;
}
/* #dvalertasistema{
    display: block;
    z-index: 97;
    margin-top: 65px;
    margin-left: 15px;
    margin-right: 15px;
    margin-bottom: -60px;
} */

#dvchat{
    z-index: 100;
    position: fixed;
    bottom: 15px;
    right: 15px;
    width: 340px;
    height: 400px;
    border-radius: 10px;
    box-shadow: 0 0 0.42857rem 0 rgba(0,0,0,.2);
    background: hsla(0,0%,100%,.98);
}
#dvtitulochat{
    cursor: move;
    padding-top  : 5px;
    padding-right: 10px;
    padding-left:  10px;
    color: white;
    background-image: linear-gradient(to right top, #242525, #303333, #3d4141, #4a5050, #586060);
    height: 40px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}
#dvtitulochat h5{
    padding-top: 5px;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 16px;
}
#dvconteudochat{
    padding: 15px;
}
#dvconteudochat label{
    margin-bottom: 2px;
}
#dvidentificacao{
    padding-bottom: 15px;
}
#dvidentificacao h5{
    font-size:18px;
    font-weight: bold;
}
#dvrodapechat{
    margin-top: 0px;
    padding: 15px;
}
#dvmsgschat{
    height: 230px;
    overflow:auto;
    padding: 0px 10px 0px 10px;
}
#dvmsgschat ul{
    width: 100%;
    padding-left: 0px;
}
#dvmsgschat li{
    list-style: none;
}
/* Chat conteudos */
#dvmsgschat p {
    margin-top: 0;
    margin-bottom: 2px;
}
#btnavaliacao{
    float: left;
    position: relative;
    top: 4px;
}
.nomeindicador{
    font-size: 16px;
    font-weight: bold;
    color: #656565;
}
.corpomsg{
    font-size: 14px;
    color: #888888;
}
.conteudo {
    border: 2px solid #dedede;
    background-color: #f1f1f1;
    border-radius: 5px;
    padding: 5px;
    margin: 10px 0;
}

/* Darker chat conteudo */
.darker {
    border-color: #ccc;
    background-color: #ddd;
}

/* Clear floats */
.conteudo::after {
    content: "";
    clear: both;
    display: table;
}

/* Style images */
.conteudo img {
    float: left;
    max-width: 26px;
    width: 100%;
    border: 2px solid #dedede;
    margin-right: 5px;
    border-radius: 50%;
}
/* Style the right image */
.conteudo img.right {
    float: right;
    border: 2px solid #666666;
    margin-left: 5px;
    margin-right:0;
}
/* Style time text */
.time-right {
    font-size: 12px;
    float: right;
    color: #aaa;
}
/* Style time text */
.time-left {
    font-size: 12px;
    float: left;
    color: #999;
}
#dvstatus{
    width: 100%;
    height: 20px;
}
#txtmsgchat{
    width: 255px;
    height: 65px;
}
#btenviarmsgchat{
    width: 45px;
    height: 65px;
    position: relative;
    top: -65px;
    left: 265px;
}
#pstatus{
    width: 100%;
    top: -8px;
    position: relative;
    font-size: 14px;
    font-weight: bold;
}
.starclear {
    font-size: 36px;
    color: #57AEF1;
    cursor: pointer;
}
.starfilled {
    font-size: 36px;
    color: #57AEF1;
    cursor: pointer;
}
.dropdown-menu-right {
    right: 0;
    left: auto;
}
.dropdown-menu.drop-notificacoes-mini {
    right: 0;
    left: auto;
    width: 100%; /* ou defina a largura desejada */
}
.btn-dashboard{
    margin-top: -5px;
    cursor: pointer;
    width: 20px; height: auto;
    transition: 0.5s;
}
.btn-dashboard:hover{    
    border-radius: 100%;
    transform: scale(1.2, 1.2);
    transition: 0.3s;
    filter: drop-shadow(0 0 2px  #b8bfce); 
}
</style>
<style scoped type="text/css">

.fil1 {fill:#3671A8}
.fil0 {fill:#1E2B37;fill-rule:nonzero}

</style>